import React, { useMemo } from 'react'
import { useFormContext } from 'react-hook-form'
import { Input, InputType } from '../../Forms/Input'
import { TextArea } from '../../Forms/TextArea'
import { TextInputProps } from '../types'
import { useDefaultValue } from '../useDefaultValue'
import { useValidationState } from '../useValidationState'
import { getValidationRules } from '../validation'

export type RHFInputProps = {
  input: TextInputProps
  readonly?: boolean
  id?: string
}

export const RHFInput = ({ input, readonly, id }: RHFInputProps) => {
  const { register } = useFormContext()

  const validationRules = useMemo(() => getValidationRules(input), [input])

  const validationState = useValidationState(input.slug)

  useDefaultValue({
    name: input.slug,
    value: input.defaultValue,
  })

  let type: InputType | 'textarea'

  switch (input.type) {
    case 'inputText':
      type = 'text'
      break
    case 'inputTextArea':
      type = 'textarea'
      break
    case 'inputEmail':
      type = 'email'
      break
    case 'inputNumber':
      type = 'number'
      break
    case 'inputPassword':
      type = 'password'
      break
  }

  return type === 'textarea' ? (
    <TextArea
      id={id}
      {...input}
      {...register(input.slug, {
        ...validationRules,
      })}
      readOnly={readonly}
      required={!!validationRules?.required}
      validation={validationState}
    />
  ) : (
    <Input
      id={id}
      {...input}
      {...register(input.slug, {
        ...validationRules,
      })}
      readOnly={readonly}
      required={!!validationRules?.required}
      type={type}
      validation={validationState}
    />
  )
}
